<template>
  <TransitionRoot :show="open" as="template">
    <Dialog class="relative z-50" @close="$emit('close')">
      <TransitionChild
        as="template"
        enter="ease-out duration-200"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-150"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/50" />
      </TransitionChild>
      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4">
          <TransitionChild
            as="template"
            enter="ease-out duration-200"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="ease-in duration-150"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              :class="[
                'w-full rounded-lg border bg-card text-card-foreground shadow-lg transition-[max-width] duration-200',
                x2l ? 'max-w-[96rem]' : xl ? 'max-w-5xl' : wide ? 'max-w-3xl' : 'max-w-lg',
              ]"
            >
              <div v-if="title || $slots.header" class="flex items-center gap-3 border-b px-4 py-3">
                <slot name="header">
                  <DialogTitle class="text-sm font-semibold">{{ title }}</DialogTitle>
                </slot>
                <button
                  class="ml-auto shrink-0 rounded-md p-1 text-muted-foreground hover:bg-accent hover:text-accent-foreground"
                  @click="$emit('close')"
                >
                  <XIcon class="h-4 w-4" />
                </button>
              </div>
              <div class="p-4">
                <slot />
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { XIcon } from "@heroicons/vue/outline";

export default {
  name: "UiDialog",
  components: { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot, XIcon },
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: "" },
    wide: { type: Boolean, default: false },
    xl: { type: Boolean, default: false },
    x2l: { type: Boolean, default: false },
  },
  emits: ["close"],
};
</script>
